import React from 'react';
import PropTypes from 'prop-types';

export default function Statistics({ newMembersCount, totalMembersCount }) {
  return (
    <p className="mt-4 fw-light">
      {newMembersCount > 0 && (
        <>
          New Employees:
          {' '}
          <span className="fw-semibold">{newMembersCount}</span>
          <br />
        </>
      )}

      Total Number Of Employees:
      {' '}
      <span className="fw-semibold">{totalMembersCount}</span>
    </p>
  );
}

Statistics.propTypes = {
  newMembersCount: PropTypes.number.isRequired,
  totalMembersCount: PropTypes.number.isRequired,
};
